import React from 'react'
import PropTypes from 'prop-types'
import SidePanelView from 'components/SidePanel'
import { useSidePanel } from 'modules/SidePanel/hooks/useSidePanel'

const SidePanel = ({ id, children = null, ...rest }) => {
  const { toggle, activeId } = useSidePanel()

  const open = activeId === id

  return (
    <SidePanelView
      open={open}
      onClose={() => toggle(null)}
      {...rest}
    >
      {children}
    </SidePanelView>
  )
}

SidePanel.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.string,
}

export default SidePanel
